import { request } from '../../Common/api/client';

function normalizePayoutError(error) {
  const payload = error?.response?.data;
  if (!payload || typeof payload !== 'object') return error;
  const normalized = new Error(payload.msg || error.message || '요청 처리에 실패했습니다.');
  normalized.code = payload.code;
  normalized.data = payload.data;
  normalized.response = error.response;
  return normalized;
}

async function payoutRequest(config) {
  try {
    return await request(config);
  } catch (error) {
    throw normalizePayoutError(error);
  }
}

function otpHeaders(otpToken) {
  return otpToken ? { 'X-OTP-Token': otpToken } : {};
}

function requireCpPrimaryKey(cpId) {
  const value = typeof cpId === 'number' ? cpId : Number(String(cpId ?? '').trim());
  if (!Number.isInteger(value) || value <= 0) {
    const error = new Error('지급 관리에는 CP 테이블의 숫자 PK가 필요합니다.');
    error.code = 4000;
    throw error;
  }
  return value;
}

export function getCpPayoutCapabilities() {
  return payoutRequest({ method: 'GET', url: '/api/admin/cp/payout-capabilities' });
}

export function getCpPayoutBalance({ startDate, endDate }) {
  return payoutRequest({
    method: 'GET',
    url: '/api/admin/cp/payout-balance',
    params: { startDate, endDate },
  });
}

export function getCpPayoutProfiles(params = {}) {
  return payoutRequest({ method: 'GET', url: '/api/admin/cp/payout-profiles', params });
}

export function getCpPayoutProfile(cpId) {
  const cpPk = requireCpPrimaryKey(cpId);
  return payoutRequest({
    method: 'GET',
    url: '/api/admin/cp/payout-profile',
    params: { cpId: cpPk },
  });
}

export function saveCpPayoutProfile({ cpId, representativeBirthDate, otpToken }) {
  const cpPk = requireCpPrimaryKey(cpId);
  return payoutRequest({
    method: 'POST',
    url: '/api/admin/cp/payout-profile',
    data: { cpId: cpPk, representativeBirthDate },
    headers: otpHeaders(otpToken),
  });
}

export function registerCpPayoutProfile({ cpId, otpToken }) {
  const cpPk = requireCpPrimaryKey(cpId);
  return payoutRequest({
    method: 'POST',
    url: '/api/admin/cp/payout-profile/register',
    data: { cpId: cpPk },
    headers: otpHeaders(otpToken),
  });
}

export function refreshCpPayoutAml({ cpId, otpToken }) {
  const cpPk = requireCpPrimaryKey(cpId);
  return payoutRequest({
    method: 'POST',
    url: '/api/admin/cp/payout-profile/aml-refresh',
    data: { cpId: cpPk },
    headers: otpHeaders(otpToken),
  });
}
